import { extractGroups, type TimelinePayload } from './learning';

export const MATERIAL_VIDEO_REMOTION_COMPOSITION_ID =
  'material-video-remotion-export';

export type MaterialVideoRenderSource = {
  title: string;
  media_url: string;
  audio_url?: string;
  media_kind: 'video' | 'image' | 'audio';
  total_duration: number;
  timeline: TimelinePayload;
};

export type MaterialVideoRenderOverrides = {
  showRomaji?: boolean;
  showFurigana?: boolean;
  showTimestamp?: boolean;
  showScrollingSubtitles?: boolean;
  karaokeMode?: boolean;
  preferEmbeddedAudio?: boolean;
};

export function buildMaterialVideoRenderProps(
  material: MaterialVideoRenderSource,
  overrides: MaterialVideoRenderOverrides = {}
) {
  const groups = extractGroups(material.timeline);
  const totalDuration =
    groups.at(-1)?.end || Math.max(0, material.total_duration || 0);
  const timelineFlags = material.timeline as TimelinePayload & {
    show_romaji?: boolean;
    show_furigana?: boolean;
    show_timeline_timestamp?: boolean;
    show_scrolling_subtitles?: boolean;
    karaoke_mode?: boolean;
  };

  return {
    title: material.title,
    mediaUrl: material.media_url,
    audioUrl: material.audio_url || '',
    groups,
    totalDuration,
    showRomaji: overrides.showRomaji ?? timelineFlags.show_romaji !== false,
    showFurigana:
      overrides.showFurigana ?? timelineFlags.show_furigana !== false,
    showTimestamp:
      overrides.showTimestamp ?? timelineFlags.show_timeline_timestamp === true,
    showScrollingSubtitles:
      overrides.showScrollingSubtitles ??
      timelineFlags.show_scrolling_subtitles !== false,
    karaokeMode: overrides.karaokeMode ?? timelineFlags.karaoke_mode === true,
    useSeparateAudioTrack:
      material.media_kind === 'video' &&
      Boolean(material.audio_url) &&
      !overrides.preferEmbeddedAudio
  };
}
